// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__MY6lt","bar":"style_bar__lMuZg"};